<template>
  <div class="home-about">
    <div class="container">
      <div class="home-about-title">{{ $t("home.IntelliMat") }}</div>
      <div class="home-about-line"></div>
    </div>
    <div class="home-about-background">
      <div class="container">
        <div class="home-about-content-left">
          <img
            class="home-about-content-img"
            src="../../assets/home/home_intellimat.jpg"
          />
        </div>
        <div class="home-about-content-right">
          <!--        <div class="home-about-content-title">北京龙讯旷腾科技有限公司</div>-->
          <div class="home-about-content-content">
            <div class="home-about-content-content-text">
              {{ $t("home.IntelliMatIntroductor" ) }}"
            </div>
          </div>
          <a
            class="home-about-content-button"
            style="display: block; text-align: center; line-height: 60px"
            @click="toIntelliMatIntroduce"
            target="_blank"
            >{{ $t("home.click") }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {},
  components: {},
  methods: {
    toIntelliMatIntroduce() {
      this.$router.push({ name: "IntelliMatIntroduce" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-about {
  margin-top: 90px;
}
.home-about-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(73, 145, 201, 1);
  line-height: 45px;
}
.home-about-line {
  margin-top: 8px;
  height: 1px;
  background: rgba(240, 240, 240, 1);
}
.home-about-background {
  margin-top: 40px;
  padding: 40px 0;
  background: rgb(255, 255, 255);
}
.home-about-content-title {
  margin-top: 20px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(73, 145, 201, 1);
  line-height: 45px;
}
.home-about-content-content {
  margin-top: 0;
}
.home-about-content-content-text {
  font-size: 20px;
  font-family: PingFangSC-Light, sans-serif;
  font-weight: 300;
  color: rgba(73, 145, 201, 1);
  line-height: 28px;
  margin-top: 4px;
}
.home-about-content-button {
  background: rgba(255, 255, 255, 0);
  border: 2px solid #4991c9;
  width: 370px;
  height: 60px;
  font-size: 24px;
  font-family: PingFangSC-Light, sans-serif;
  font-weight: 300;
  color: rgba(73, 145, 201, 1);
  line-height: 33px;
  margin-top: 24px;
  cursor: pointer;
}
.home-about-content-button:hover,
.home-about-content-button:active,
.home-about-content-button:focus {
  box-shadow: none !important;
  outline: none !important;
}
.home-about-content-left {
  display: inline-block;
  float: left;
  width: 550px;
}
.home-about-content-right {
  display: inline-block;
  vertical-align: top;
  margin-left: 50px;
  width: 500px;
}
.home-about-content-img {
  display: block;
  width: 550px;
}
</style>
